module.exports = __webpack_public_path__ + "img/accountTree2x.png?fb9e1a5768a121f0f6b9a0971e60e623";